import { FC } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useCapacityManagementRoot } from 'src/apis/capacity-management/use-capacity-management-root';
import { useMonthlyStatements } from 'src/apis/capacity-management/use-monthly-statements';
import { Alert } from 'src/components/feedback/alert';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { Stack } from 'src/components/layout/stack';
import { Heading } from 'src/components/text/heading';
import { CorrectionsOverview } from 'src/pages/reporting/monthly-statements/corrections';
import { CreateMonthlyStatement } from 'src/pages/reporting/monthly-statements/create';
import { CurtailmentsOverview } from 'src/pages/reporting/monthly-statements/curtailments';
import { EditMonthlyStatement } from 'src/pages/reporting/monthly-statements/edit';
import { MonthlyStatementsOverview } from 'src/pages/reporting/monthly-statements/overview';

export const MonthlyStatements: FC = () => {
  const capacityManagementRoot = useCapacityManagementRoot();

  // share this resource across sub-pages, so it is not unnecessary re-fetchted,
  // but every page takes care of fetching it initially individually (because
  // the initial params might differ and _some_ sub-pages might not need it)
  const monthlyStatements = useMonthlyStatements();

  if (monthlyStatements.error)
    return (
      <Stack gap={2}>
        <Heading mode="title">Monthly Statements</Heading>

        <Alert type="warning">
          Monthly Statements can only be used, if you are using the PRISMA
          capacity management service.
        </Alert>
      </Stack>
    );

  return (
    <Switch>
      <Redirect
        path="/reporting/monthly-statements"
        exact
        to="/reporting/monthly-statements/overview"
      />

      <Route path="/reporting/monthly-statements/overview">
        <MonthlyStatementsOverview
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route path="/reporting/monthly-statements/corrections">
        <CorrectionsOverview capacityManagementRoot={capacityManagementRoot} />
      </Route>

      <Route path="/reporting/monthly-statements/curtailments">
        <CurtailmentsOverview capacityManagementRoot={capacityManagementRoot} />
      </Route>

      <Route path="/reporting/monthly-statements/create">
        <CreateMonthlyStatement
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route path="/reporting/monthly-statements/:monthlyStatementId/edit">
        <EditMonthlyStatement
          capacityManagementRoot={capacityManagementRoot}
          monthlyStatements={monthlyStatements}
        />
      </Route>

      <Route>
        <ThrowNotFound />
      </Route>
    </Switch>
  );
};
